module.exports = __webpack_public_path__ + "img/wired.f06bee4f.svg";